<template>
  <div
    class="vx-card p-6 flex flex-col"
    id="labor-dashboard"
    ref="laborDashboard"
  >
    <!-- アラート表示領域 -->
    <div class="flex items-center flex-wrap">
      <div class="latest-alert-label">直近のアラート<br />発生船舶隻数</div>
      <div id="alert-area" class="flex items-center flex-wrap gap-3">
        <!-- 時間超過  -->
        <div id="count-overtime" class="vx-card alert-card">
          <span class="number" :class="overtimeAlertColor">{{ overtime }}</span>
          <span class="people" :class="overtimeAlertColor">隻</span>
          <div class="description-area">
            <div class="description">時間超過</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <alert-tooltip
                  ><template v-slot:alert-title
                    >過去48時間以内に以下のアラートが発生している隻数を表示しています。</template
                  >
                  <template v-slot:alert-item
                    >・過去24時間の労働時間が14時間超<br />
                    ・過去7日間の労働時間が72時間超<br />
                    ・過去28日間の時間外労働時間が56時間超</template
                  >
                </alert-tooltip>
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
        <!-- 休憩不足 -->
        <div id="count-lack-of-rest" class="vx-card alert-card">
          <span class="number" :class="countLackOfRestAlertColor">{{
            lackOfRest
          }}</span>
          <span class="people" :class="countLackOfRestAlertColor">隻</span>
          <div class="description-area">
            <div class="description">連続休息6時間未満</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <alert-tooltip
                  ><template v-slot:alert-title
                    >過去48時間以内に以下のアラートが発生している隻数を表示しています。</template
                  >
                  <template v-slot:alert-item
                    >・1日間のうち最長の休息時間が6時間未満</template
                  >
                </alert-tooltip>
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
        <!-- 時間超過の恐れ -->
        <div id="count-fear-of-overtime" class="vx-card alert-card">
          <span class="number" :class="countFearOfOvertimeAlertColor">{{
            fearOfOvertime
          }}</span>
          <span class="people" :class="countFearOfOvertimeAlertColor">隻</span>
          <div class="description-area">
            <div class="description">時間超過の恐れ</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <alert-tooltip
                  ><template v-slot:alert-title
                    >過去48時間以内に以下のアラートが発生している隻数を表示しています。</template
                  >
                  <template v-slot:alert-item
                    >・過去24時間の労働時間が10時間以上〜14時間以内<br />
                    ・過去4日間の労働時間が40時間以上<br />
                    ・過去5日間の労働時間が50時間以上<br />
                    ・過去6日間の労働時間が60時間以上<br />
                    ・過去7日間の労働時間が68時間以上〜72時間以内</template
                  >
                </alert-tooltip>
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
      </div>
    </div>

    <!-- フィルターエリア -->
    <div class="filter-area">
      <vs-divider />
      <div class="flex items-center">
        <treeselect
          v-model="selectedFilterVessels"
          :options="vesselFilterOptions"
          :multiple="true"
          placeholder="すべての船舶"
          :limit="1"
          :limitText="count => `+${count}`"
          noOptionsText="なし"
          class="mr-4 my-1"
          @input="onFilterChanged"
          noResultsText="見つかりませんでした"
        ></treeselect>
        <treeselect
          v-model="selectedFilterVesselOwners"
          :options="vesselOwnerFilterOptions"
          :multiple="true"
          placeholder="すべての船舶所有者"
          :limit="1"
          :limitText="count => `+${count}`"
          noOptionsText="なし"
          class="mr-4 my-1"
          @input="onFilterChanged"
          noResultsText="見つかりませんでした"
        ></treeselect>
        <treeselect
          v-model="selectedFilterDepartments"
          :options="departmentFilterOptions"
          :multiple="true"
          placeholder="すべての部署"
          :limit="1"
          :limitText="count => `+${count}`"
          noOptionsText="なし"
          class="mr-4 my-1"
          @input="onFilterChanged"
          noResultsText="見つかりませんでした"
        ></treeselect>
      </div>
      <vs-divider />
    </div>
    <ag-grid-vue
      class="ag-theme-material w-100 my-6 ag-grid-table flex-shrink-1"
      ref="agGridTableCrewStatusList"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="rowData"
      colResizeDefault="shift"
      :suppressCellFocus="true"
      :animateRows="false"
      :floatingFilter="false"
    >
    </ag-grid-vue>

    <!-- ページネーション領域 -->
    <div class="flex justify-end items-center" style="margin: 0.6rem 0">
      <div style="margin-right: 2rem">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ fromDataCount }}
              -
              {{ toDataCount }}
              / {{ totalDataCount }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- ページに表示するレコードを変更 -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="onChangePageSize(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(75)">
              <span>75</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- ページネーション -->
      <div>
        <vs-pagination
          v-if="isReadyPagination"
          :total="pageable.total_pages"
          :max="7"
          v-model="currentPage"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { toYMD } from "@/utils/DateUtil.js";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseUnitRepository = AiseaApiFactory.get("enterpriseUnit");
const enterpriseOwnerRepository = AiseaApiFactory.get("enterpriseOwner");
const enterpriseOwnerManningVesselTimesheetRecordRepository = AiseaApiFactory.get(
  "enterpriseOwnerManningVesselTimesheetRecord"
);

import AlertTooltip from "./tooltip-text/AlertTooltip.vue";
import CellRendererLink from "../components/CellRendererLink.vue";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";

export default {
  name: "LaborDashboard",
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    AgGridVue,
    Treeselect,
    VxTooltipWithSlotText,
    AlertTooltip,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
  },
  data() {
    return {
      selectedFilterVessels: [],
      selectedFilterDepartments: [],
      selectedFilterVesselOwners: [],

      departmentFilterOptions: [],
      vesselOwnerFilterOptions: [],
      vesselFilterOptions: [],

      columnDefs: null,
      gridColumnApi: null,
      rowData: [],
      gridApi: null,
      overtime: null,
      lackOfRest: null,
      fearOfOvertime: null,
      actionButtonTimer: null,
      agGridScrollPosition: -1,
      isReadyPagination: true,
      alertColorClass: "alert-color",
      warningColorClass: "warning-color",
      normalColorClass: "normal-color",

      hoverMenuClassList: [
        "hover-menu-hour-of-work-24h",
        "hover-menu-hour-of-rest-24h",
        "hover-menu-hour-of-work-1h",
      ],
      gridOptions: {
        localeText: { noRowsToShow: "表示する船員労務状況がありません" },
        context: {
          componentParent: this,
        },
      },

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      inputSearchCondition: {
        enterprise_manning_vessel_ids: [],
        enterprise_team_ids: [],
        owner_enterprise_ids: [],
        now: toYMD(Date.now(), null),
        page: 0,
        size: 50,
      },

      currentPage: 1,
      pageSize: 50,

      defaultColDef: {
        resizable: true,
        sortable: false,
        wrapText: true,
        autoHeight: false,
      },
    };
  },
  watch: {
    currentPage() {
      this.inputSearchCondition.page = this.getCurrentPage();
      this.searchCrewTimesheetRecords();
    },
  },
  computed: {
    fromDataCount() {
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    toDataCount() {
      return this.totalDataCount - this.currentPage * this.pageSize > 0
        ? this.currentPage * this.pageSize
        : this.totalDataCount;
    },
    totalDataCount() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },

    overtimeAlertColor() {
      if (this.overtime > 0) return this.alertColorClass;
      return this.normalColorClass;
    },
    countLackOfRestAlertColor() {
      if (this.lackOfRest > 0) return this.alertColorClass;
      return this.normalColorClass;
    },
    countFearOfOvertimeAlertColor() {
      if (this.fearOfOvertime > 0) return this.warningColorClass;
      return this.normalColorClass;
    },

    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return this.pageSize;
    },
  },
  methods: {
    onFilterChanged() {
      console.log(this.selectedFilterVessels);
      this.inputSearchCondition = {
        ...this.inputSearchCondition,
        ...{
          enterprise_manning_vessel_ids: this.selectedFilterVessels.toString(),
          enterprise_team_ids: this.selectedFilterDepartments.toString(),
          owner_enterprise_ids: this.selectedFilterVesselOwners.toString(),
        },
      };

      this.initializePageIndex();
      this.fetchVesselTimesheetRecord(this.inputSearchCondition);
    },

    initializePageIndex() {
      this.currentPage = 1;
    },

    onChangePageSize(size) {
      this.gridApi.paginationSetPageSize(size);
      this.pageSize = size;
      this.currentPage = 1;
      this.inputSearchCondition.size = size;

      this.fetchVesselTimesheetRecord(this.inputSearchCondition);
    },

    async searchCrewTimesheetRecords() {
      await this.fetchVesselTimesheetRecord(this.inputSearchCondition);
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },
    onFirstDataRendered(_) {
      this.autoSizeAll();
    },

    async fetchFilterOptions() {
      const payload = {
        page: 0,
        size: 1000,
      };
      try {
        const res = await Promise.all([
          enterpriseUnitRepository.fetchUnits(payload),
          enterpriseOwnerRepository.fetchOwners(payload),
          enterpriseOwnerRepository.fetchManningVessels(payload),
        ]);
        if (!res[0].status || !res[1].status || !res[2].status) return;
        this.departmentFilterOptions = res[0].data.enterprise_teams.map(
          item => {
            return {
              id: item.id,
              label: item.name,
            };
          }
        );
        this.vesselOwnerFilterOptions = res[1].data.enterprises.map(item => {
          return {
            id: item.id,
            label: item.name,
          };
        });
        this.vesselFilterOptions = res[2].data.manning_vessels.map(item => {
          return {
            id: item.id,
            label: item.name,
          };
        });
      } catch (error) {
        this.$vs.notify({
          title: "予期せぬエラーが発生しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        return;
      }
    },

    async fetchVesselTimesheetRecord(searchCondition) {
      try {
        const res = await enterpriseOwnerManningVesselTimesheetRecordRepository.fetchRecords(
          searchCondition
        );
        if (!res.status) return;
        this.overtime = res.data.overtime;
        this.lackOfRest = res.data.lack_of_rest;
        this.fearOfOvertime = res.data.fear_of_overtime;
        this.rowData =
          res.data.inline_response_enterprise_owner_manning_vessel_timesheet_records;
        this.pageable = res.data.pageable;

        this.currentPage = searchCondition.page + 1;
      } catch (error) {
        this.$vs.notify({
          title: "予期せぬエラーが発生しました。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        return;
      }
    },

    autoSizeAll() {
      if (this.gridColumnApi) {
        let allColumnIds = [];
        if (this.gridColumnApi && this.gridColumnApi.getAllColumns()) {
          this.gridColumnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.getId());
          });
          this.gridColumnApi.autoSizeColumns(allColumnIds, false);
        }
        if (
          this.$refs.agGridTableAdminAccount &&
          this.$refs.agGridTableAdminAccount.$el.getBoundingClientRect().width >
            0
        ) {
          this.gridApi.sizeColumnsToFit(); // TODO: 横スクロールありの場合は、別途調整
        }
      }
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "運航船名",
        field: "vessel_name",
        colId: "vessel_name",
        cellRenderer: "CellRendererLink",
        width: 240,
      },

      {
        headerName: "船舶所有者",
        field: "owner_enterprise_name",
        colId: "owner_enterprise_name",
        width: 240,
      },

      {
        headerName: "労働時間\n/24h",
        field: "number_of_crew_with_work24h",
        cellClassRules: {
          "cell-danger": params =>
            params.data.is_number_of_crew_with_work24h_critical,
          "cell-warn": params =>
            params.data.is_number_of_crew_with_work24h_warning,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_work24h",
        width: 100,
      },
      {
        headerName: "連続休息時間",
        field: "number_of_crew_with_rest24h",
        cellClassRules: {
          "cell-danger": params =>
            params.data.is_number_of_crew_with_rest24h_critical,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_rest24h",
        width: 100,
      },
      {
        headerName: "過去4日間以内\nの労働時間",
        field: "number_of_crew_with_work4d",
        cellClassRules: {
          "cell-warn": params =>
            params.data.is_number_of_crew_with_work4d_warning,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_work4d",
        width: 100,
      },
      {
        headerName: "過去5日間以内\nの労働時間",
        field: "number_of_crew_with_work5d",
        cellClassRules: {
          "cell-warn": params =>
            params.data.is_number_of_crew_with_work5d_warning,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_work5d",
        width: 100,
      },
      {
        headerName: "過去6日間以内\nの労働時間",
        field: "number_of_crew_with_work6d",
        cellClassRules: {
          "cell-warn": params =>
            params.data.is_number_of_crew_with_work6d_warning,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_work6d",
        width: 100,
      },
      {
        headerName: "過去7日間以内\nの労働時間",
        field: "number_of_crew_with_work1w",
        cellClassRules: {
          "cell-danger": params =>
            params.data.is_number_of_crew_with_work1w_critical,
          "cell-warn": params =>
            params.data.is_number_of_crew_with_work1w_warning,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_work1w",
        width: 100,
      },
      {
        headerName: "過去28日間\nの時間外労働時間",
        field: "number_of_crew_with_overtime_work28d",
        cellClassRules: {
          "cell-danger": params =>
            params.data.is_number_of_crew_with_overtime_work28d_critical,
        },
        valueFormatter: params => params.value + "人",
        colId: "number_of_crew_with_overtime_work28d",
        width: 100,
      },
    ];

    this.gridOptions = {
      ...this.gridOptions,
      onFirstDataRendered: this.onFirstDataRendered,
    };
  },
  async created() {
    await this.fetchFilterOptions().then(() => {
      this.fetchVesselTimesheetRecord(this.inputSearchCondition);
    });
  },

  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#labor-dashboard {
  --vs-primary: 3, 155, 229;

  .ag-cell {
    font-size: 16px;
    font-weight: 400;
  }

  .ag-header-cell-text {
    font-size: 12px;
    font-weight: 600;
  }

  .latest-alert-label {
    margin-right: 10px;
    font-size: 15px;
    font-weight: 600;
  }

  #alert-area {
    flex-grow: 1;
    .alert-card {
      width: 210px;
      height: 80px;
      padding: 8px 16px;
      border-radius: 6px;

      .number {
        font-size: 26px;
        font-weight: 600;
      }

      .people {
        font-size: 14px;
        font-weight: 400;
      }

      .description-area {
        display: flex;
        .description {
          font-size: 14px;
          font-weight: 600;
          flex-grow: 1;
        }
        .info-icon .material-icons {
          color: $aisea-mouse-gray;
          transition: 0.3s;
          &:hover {
            color: $aisea-gray;
          }
        }
      }

      .alert-color {
        color: #ff5252;
      }
      .warning-color {
        color: #ffd54f;
      }
      .normal-color {
        color: #4fb0f7;
      }
    }
  }

  .ag-theme-material {
    font-size: 12px;
    overflow: visible;
  }

  .ag-header-cell-label .ag-header-cell-text {
    white-space: pre-wrap !important;
    overflow: visible;
    overflow-wrap: break-word;
  }

  .cell-warn {
    color: $aisea-white;
    background-color: #ffbf00;
    font-weight: 600;
  }

  .cell-danger {
    color: $aisea-white;
    background-color: #eb5f56;
    font-weight: 600;
  }
}
</style>
